import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const NEARBY = [
  { href: '/modiya-mahadev', label: 'Modiya Mahadev' },
  { href: '/paangarh', label: 'Paangarh' },
  { href: '/bijaipur', label: 'Bijaipur' },
];

// Links are plain <a href> on purpose: every route is prerendered, so a full
// page load serves real HTML and keeps the pages independent of each other.
const Nav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // Lock the page behind the mobile sheet.
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const current = (href) => (pathname === href ? 'page' : undefined);

  return (
    <>
      <nav className="nav" role="navigation" aria-label="Main">
        <div className="nav__inner">
          <a className="nav__logo" href="/">
            Amarpura
          </a>

          <ul className="nav__list">
            <li className="nav__item">
              <a className="nav__link" href="/" aria-current={current('/')}>
                Home
              </a>
            </li>
            <li className="nav__item">
              <a
                className="nav__link"
                href="/about"
                aria-current={current('/about')}
              >
                About
              </a>
            </li>
            <li className="nav__item">
              {/* Opens on hover or keyboard focus via CSS :focus-within. */}
              <button type="button" className="nav__link" aria-haspopup="true">
                Near By
              </button>
              <ul className="nav__dropdown">
                {NEARBY.map(({ href, label }) => (
                  <li key={href}>
                    <a href={href} aria-current={current(href)}>
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
            <li className="nav__item">
              <a
                className="nav__link"
                href="/contact-us"
                aria-current={current('/contact-us')}
              >
                Contact
              </a>
            </li>
          </ul>

          <button
            type="button"
            className="nav__toggle"
            aria-expanded={open}
            aria-controls="nav-sheet"
            onClick={() => setOpen((v) => !v)}
          >
            <span />
            <span />
            <span className="visually-hidden">Menu</span>
          </button>
        </div>
      </nav>

      <div
        id="nav-sheet"
        className={`nav__sheet${open ? ' is-open' : ''}`}
        hidden={!open}
      >
        <ul>
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/about">About</a>
          </li>
          <li className="nav__sheet-group">Near By</li>
          {NEARBY.map(({ href, label }) => (
            <li key={href} className="nav__sheet-sub">
              <a href={href}>{label}</a>
            </li>
          ))}
          <li>
            <a href="/contact-us">Contact</a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Nav;
